export enum SseEventType {
  SESSION_ALERTS_UPDATED = "session-alerts.updated",
  HEARTBEAT = "heartbeat",
}
